import { api } from './client';
import type { PlatformCompany, PlatformStats, Paginated } from '@/types';

export const platformApi = {
  async companies(filters: { plan?: string; is_active?: string; search?: string } = {}): Promise<PlatformCompany[]> {
    const { data } = await api.get<Paginated<PlatformCompany>>('/platform/companies/', { params: filters });
    return data.results ?? (data as unknown as PlatformCompany[]);
  },
  async stats(): Promise<PlatformStats> {
    const { data } = await api.get<PlatformStats>('/platform/stats/');
    return data;
  },
  async setPlan(id: number, plan: string): Promise<PlatformCompany> {
    const { data } = await api.post<PlatformCompany>(`/platform/companies/${id}/set-plan/`, { plan });
    return data;
  },
  async toggleActive(id: number): Promise<boolean> {
    const { data } = await api.post<{ is_active: boolean }>(`/platform/companies/${id}/toggle-active/`);
    return data.is_active;
  },
};
